import { render, staticRenderFns } from "./TeacherSolutionLMS.vue?vue&type=template&id=9bb01752&"
import script from "./TeacherSolutionLMS.vue?vue&type=script&lang=js&"
export * from "./TeacherSolutionLMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports